import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import EdtDynamicCheckLogTableService from '../service/EdtDynamicCheckLogTableService';

const config = {
	key: 'edtDynamicCheckLogTable',
	topic: 'edtDynamicCheckLog',
	service: EdtDynamicCheckLogTableService,
	editFormState: item => `/edt-dynamic-check-log/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}edtDynamicCheckLogTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		}
	]
};

function EdtDynamicCheckLogTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('edtDynamicCheckLogTable', reducer('edtDynamicCheckLogTable'))(EdtDynamicCheckLogTable);
